import React from 'react';
import { Typography } from '@mui/material';

export default function TwoFactorAuthentication() {
    return (
        <Typography variant="h5">
            Autenticación de Dos Factores
        </Typography>
    );
}
